var _path, _path2, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileGooglePlayLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fill: "#5F787E",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 1.096v13.81c0 .481.278.897.681 1.096L9.34 8.001 1.352 0a1.218 1.218 0 00-.685 1.096zm2.472 14.489l8.734-5.049-1.846-1.848-6.888 6.897zm11.45-8.552a1.22 1.22 0 01.012 1.927l-1.854 1.071-2.031-2.033 2.029-2.031 1.844 1.066zm-2.717-1.571L3.144.417l6.883 6.892 1.845-1.847z",
    fill: "#5F787E"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mobileGooglePlayLogo_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 1.096v13.81c0 .481.278.897.681 1.096L9.34 8.001 1.352 0a1.218 1.218 0 00-.685 1.096zm2.472 14.489l8.734-5.049-1.846-1.848-6.888 6.897zm11.45-8.552a1.22 1.22 0 01.012 1.927l-1.854 1.071-2.031-2.033 2.029-2.031 1.844 1.066zm-2.717-1.571L3.144.417l6.883 6.892 1.845-1.847z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mobileGooglePlayLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F787E",
    d: "M0 0h16v16H0z"
  }))));
}
export default SvgMobileGooglePlayLogo;